import { gql } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';
import { PORTFOLIO_FRAGMENT } from './portfolio-fragment';

export const queryFn = async (id: string) => {
  const response = await gqlClient.request(
    gql(
      `
      query getPortfolio($id: String!) {
        Portfolio(id: $id) {
          ...portfolioFields
        }
      }
      
    `,
      [PORTFOLIO_FRAGMENT]
    ),
    { id }
  );

  if ('Portfolio' in response) {
    return response.Portfolio;
  }
};
